import React, { useEffect, useMemo, useState, useRef } from "react";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { chatRoomConversations, pushChatMessage } from "../../../app/store";
import { getChatMessages, pushMessage } from "../../../store/chats/actions";
import MessageLoading from "./MessageLoading";
import UserAvatar from "../../../globalComponents/UserAvatar";
import {
  Simplecontainer,
  CurrentChat,
  MessageContentContainer,
  SendMessage,
  SendMessageInput,
  MessageButton,
  TextChatInput,
} from "../Style";
import { AiOutlineSend } from "react-icons/ai";
import NoMessageSelected from "./NoMessageSelected";

const UserMessageText = styled.div<{ isUser: boolean }>`
  max-width: 200px;
  border-radius: 12px;
  background: ${(prop) =>
    prop.isUser ? prop.theme.primaryColor : prop.theme.foreground};
  padding: 5px 10px;
  margin: 2px;
  box-shadow: ${(prop) => prop.theme.shadow};
  color: ${(prop) => (prop.isUser ? prop.theme.white : prop.theme.color)};
  font-size: 13px;
`;

const DateDiv = styled.div`
  width: fit-content;
  margin: 5px auto;
  background: ${(props) => props.theme.grey};
  padding: 1px 2px;
  color: white;
  font-size: 10px;
  border-radius: 10px;
`;
const Timediv = styled.div``;

const UserMessageChatTextContainer = styled.div<{
  isUser: boolean;
  isPreviousSender: boolean;
}>`
  align-self: ${(prop) => (!prop.isUser ? "flex-start" : "flex-end")};
  margin-top: ${(prop) => (prop.isPreviousSender ? "2px" : "7px")};
`;

const UserMessage = ({
  sendId,
  message,
  img,
  userId,
  name,
  date,
  previousTime,
  currentTime,
  // senderTime,
  previousSender,
}: {
  sendId: number;
  message: string;
  img?: string;
  userId: number;
  name?: string;
  date?: string;
  previousTime?: string;
  currentTime?: string;
  senderTime?: string;
  previousSender: number | undefined | null;
}) => {
  const isUserMessage = sendId.toString() === userId.toString();
  console.log("the date", date);
  const isPreviousSender = sendId.toString() === previousSender?.toString();

  const timer = (theTime: any, prevTime: any) => {
    console.log("prevTime", prevTime);
    const t1 = theTime.split(":");
    const t2 = `${t1[0]}:${t1[1]}`;
    const t3 = prevTime.split(":");
    console.log("t3", t3);
    const t4 = `${t3[0]}:${t3[1]}`;
    if (sendId.toString() === previousSender?.toString()) {
      if (t2 !== t4) {
        return t2;
      } else if (t2 === t4) {
        return " ";
      }
    } else {
      return t2;
    }
  };
  console.log("return is", timer(currentTime, previousTime));
  return (
    <>
      {date && <DateDiv>{date}</DateDiv>}
      <small
        style={{
          margin: 0,
          display: "flex",
          padding: "0 10px",
          justifyContent: isUserMessage ? "flex-end" : "flex-start",
        }}
      >
        {timer(currentTime, previousTime)}
      </small>
      <UserMessageChatTextContainer
        isUser={isUserMessage}
        isPreviousSender={isPreviousSender}
      >
        {!isPreviousSender && (
          <div
            style={{
              display: "flex",
              justifyContent: isUserMessage ? "flex-end" : "flex-start",
            }}
          >
            {/* <UserAvatar img={img} username={name} size={30} /> */}
          </div>
        )}

        <UserMessageText isUser={isUserMessage}>{message}</UserMessageText>
      </UserMessageChatTextContainer>
    </>
  );
};

function MessagesContainer({ chatroom_id }: { chatroom_id: number | null }) {
  // const getRoomChats = useAppSelector(state => Object.values(state?.textChat?.entities).filter(data=> String(data?.chatroom_id) === String(chatroom_id)))
  const getRoomChats = useAppSelector((state) =>
    state.textChat.chatMessages.filter(
      (data) => String(data?.chatroom_id) === String(chatroom_id)
    )
  );
  const isMessagesLoading = useAppSelector(
    (state) => state.textChat.isMessagesLoading
  );
  const getRoomInfo = useAppSelector((state) =>
    state.textChat.myChats.filter((data) => data.id === chatroom_id)
  );
  const dispatcher = useAppDispatch();
  const userInfo = useAppSelector((state) => state.userInfoReducer.content);
  const messageContainerRef = useRef(null);
  const messageInput = useRef<any>();
  const message = useRef("");

  function updateScroll() {
    var element = messageContainerRef.current;
    if (element === undefined) return;
    //@ts-ignore
    element.scrollTop = element?.scrollHeight;
  }

  useEffect(() => {
    if (chatroom_id === null) return;
    dispatcher(getChatMessages(chatroom_id));
    return () => {};
  }, [chatroom_id]);

  useEffect(() => {
    updateScroll();
  }, [getRoomChats]);
  const createDate = (date: string | number) => {
    if (date === null || date === undefined) {
      return;
    }
    const newDate = new Date(date);
    const time = `${newDate.getHours()}:${newDate.getMinutes()}`;
    const myDate = `${newDate.getUTCFullYear()}-${newDate.getUTCMonth()}-${newDate.getUTCDay()}`;
    return { time, date: myDate };
  };
  const chats = useMemo(
    () =>
      getRoomChats?.map((data, index) => (
        <UserMessage
          date={
            createDate(getRoomChats[index - 1]?.created_at)?.date ===
            createDate(getRoomChats[index]?.created_at)?.date
              ? ""
              : createDate(data?.created_at)?.date || ""
          }
          previousTime={
            createDate(getRoomChats[index - 1]?.created_at)?.time ||
            createDate(getRoomChats[index]?.created_at)?.time
          }
          currentTime={createDate(getRoomChats[index]?.created_at)?.time}
          img={getRoomInfo[0]?.user[0]?.photolink}
          name={getRoomInfo[0]?.name}
          key={`${data?.id}`}
          message={data?.message || ""}
          sendId={data?.user_id || 0}
          previousSender={getRoomChats[index - 1]?.user_id}
          userId={userInfo.id}
        />
      )),
    [getRoomChats, userInfo.id]
  );
  console.log("chatssss", chats);
  // const tempChats = useMemo(
  //   () =>
  //   getTempRoomChats?.map((data, index) => (
  //       <UserMessage
  //           key={`${data.temp_key}`}
  //         message={data?.message || ""}
  //         sendId={data?.user_id || 0}
  //         previousSender={getRoomChats[index - 1]?.user_id}
  //         userId={userInfo.id}
  //       />
  //     )),
  //   [getTempRoomChats, userInfo.id]
  // );

  function sendUserMessage() {
    if (message.current.length < 1) return;
    if (messageInput.current.value.length > 0) {
      dispatcher(
        pushMessage({
          chatroom_id,
          message: message.current.trim(),
          user_id: userInfo.id,
          created_at: +Date.now(),
        })
      );
    }
    message.current = "";
    console.log(messageInput.current);
    messageInput.current.value = "";
  }
  console.log("message", getRoomInfo);
  return (
    <>
      <div style={{ height: "100%", flex: 1 }}>
        <Simplecontainer>
          {chatroom_id && (
            <CurrentChat>
              <img
                src={
                  getRoomInfo[0]?.user[0]?.photolink
                    ? getRoomInfo[0]?.user[0]?.photolink
                    : "https://images.unsplash.com/photo-1611606063065-ee7946f0787a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8bWVzc2FnZXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                }
                alt="user"
              />

              <h3 className="title-medium">{getRoomInfo?.[0]?.name || " "}</h3>
            </CurrentChat>
          )}
          <MessageContentContainer ref={messageContainerRef}>
            {isMessagesLoading && <MessageLoading />}
            {!chatroom_id && <NoMessageSelected />}
            <>{chatroom_id && chats}</>
          </MessageContentContainer>

          {chatroom_id && (
            <SendMessage>
              <TextChatInput
                // autoSize={{ minRows: 1, maxRows: 2 }}
                // bordered={false}
                onKeyDown={(e) => {
                  e.keyCode === 13 && sendUserMessage();
                }}
                ref={messageInput}
                placeholder="Type your message..."
                onChange={(e) => (message.current = e.currentTarget.value)}
              />

              {
                <MessageButton onClick={() => sendUserMessage()}>
                  <AiOutlineSend />
                </MessageButton>
              }
            </SendMessage>
          )}
        </Simplecontainer>
      </div>
    </>
  );
}

export default MessagesContainer;
